import React, { useEffect, useMemo, useRef, useState } from 'react';
import AppHeader from './components/appHeader';
import useUserData from './contexts/userData';
import { TransactionsUpdater } from './components/pages/creamShop/TransactionsUpdater';
import { LoggedInRoutes, LoggedOutRoutes } from './routes';
import AppMenu from './components/appMenu';
import MainBackgroundWrapper, {
  BgMode
} from './components/mainBackgroundWrapper';
import useInitFight, { FightPageModeMarkers } from './contexts/initFight';
import { useLocation } from 'react-router-dom';
import { useAssets } from './contexts/assets';

function App() {
  const { setAppLoading } = useAssets();
  const { loggedIn, userDataLoading } = useUserData();
  const initiated = useRef(false);
  const location = useLocation();
  const { mode } = useInitFight();
  const [menuOpened, setMenuOpened] = useState(false);

  useEffect(() => {
    if (!userDataLoading && !initiated.current) {
      initiated.current = true;
      setAppLoading(false);
    }
  }, [userDataLoading]);

  const closeMenu = () => setMenuOpened(false);
  const switchMenu = () => setMenuOpened((prev) => !prev);

  const bgMode = useMemo<BgMode>(() => {
    const path = location.pathname.split('/')[1];
    if (!loggedIn) {
      if (path === '' || path === 'market' || path === 'mobileapp')
        return 'inactive';
      return 'center';
    }
    if (path === '') {
      //home
      switch (mode.marker) {
        case FightPageModeMarkers.PICK:
          return 'pick';
        case FightPageModeMarkers.BATTLE:
          return 'fight';
        case FightPageModeMarkers.RESULTS:
          return 'center';
      }
    }
    if (path === 'creamshop') return 'cream';
    if (path === 'market') return 'market';
    if (path === 'about') return 'inactive';
    if (path === 'testing') return 'fight';
    return 'center';
  }, [location.pathname, mode, loggedIn]);

  if (userDataLoading) return null;

  return (
    <>
      <AppHeader
        menuOpened={menuOpened}
        closeMenu={closeMenu}
        switchMenu={switchMenu}
      />
      <AppMenu opened={menuOpened} onClose={closeMenu} />
      <TransactionsUpdater />
      <MainBackgroundWrapper mode={bgMode}>
        {loggedIn ? <LoggedInRoutes /> : <LoggedOutRoutes />}
      </MainBackgroundWrapper>
    </>
  );
}

export default App;
